import { render, staticRenderFns } from "./ChatBoard.vue?vue&type=template&id=18a6840a&"
import script from "./ChatBoard.vue?vue&type=script&lang=ts&"
export * from "./ChatBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports